module.exports = __webpack_public_path__ + "img/misc_send.e7673883.svg";